import { render, staticRenderFns } from "./taskDia.vue?vue&type=template&id=8163d046&scoped=true"
import script from "./taskDia.vue?vue&type=script&lang=js"
export * from "./taskDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8163d046",
  null
  
)

export default component.exports